import React, {useState} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Link from '@/links';
import PictureWrapper from '@/ui/images-wrapper';
import styles from './box-grid.module.scss';

const propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
  border: PropTypes.string,
  flipEnabled: PropTypes.bool,
  Url: PropTypes.string,
  UrlCopy: PropTypes.string,
  target: PropTypes.string,
  imgPath: PropTypes.string,
  imageUrl: PropTypes.string,
  imageTypeFallback: PropTypes.string,
  altImage: PropTypes.string,
  minHeight: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

const BoxGrid = ({
  children,
  backgroundColor,
  border,
  flipEnabled = false,
  Url,
  UrlCopy,
  target = '_self',
  imgPath,
  imageUrl,
  imageTypeFallback,
  altImage,
  minHeight,
  width,
  height,
  className
}) => {
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    if (flipEnabled) {
      setFlipped(!flipped);
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleFlip();
    }
  };

  return (
    <div
      className={cx(styles['box-grid'], className, {
        [styles[`box-grid--bordered-${border}`]]: border,
        [styles['box-grid--flipped']]: flipped
      })}
      style={minHeight ? {minHeight: `${minHeight}px`} : {}}>
      {/* Front Side */}
      <div
        className={cx(styles['box-grid__front'], {
          [styles['box-grid__front--with-link']]: Url,
          [styles['box-grid__front--flip']]: flipEnabled
        })}
        style={{backgroundColor}}>
        {children}

        {/* If there's arrow at the bottom */}
        {flipEnabled && (
          <div
            role="button"
            tabIndex={0}
            className={styles['box-grid__arrow-holder--flip']}
            onClick={handleFlip}
            onKeyDown={handleKeyDown}
            aria-label="Flip card">
            <span className={styles['box-grid__arrow']} />
          </div>
        )}

        {/* If there's link at the bottom */}
        {Url && (
          <div
            className={styles['box-grid__arrow-holder--link']}>
            <Link href={Url} variant="cta-default-xs" target={target}>
              {UrlCopy}
            </Link>
          </div>
        )}
      </div>
      {/* Back Side */}
      {flipEnabled && (
        <div
          className={styles['box-grid__back']}
          onClick={handleFlip}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label="Flip card back">
          <div className={styles['box-grid__close']} />
          {imageUrl && (
            <PictureWrapper
              imgPath={imgPath}
              imageUrl={imageUrl}
              imageTypeFallback={imageTypeFallback}
              altImage={altImage}
              width={width}
              height={height}
            />
          )}
        </div>
      )}
    </div>
  );
};

BoxGrid.propTypes = propTypes;

export default BoxGrid;
